interface HeaderProps {
  onMenuClick: () => void
}

export default function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className="h-16 glass border-b border-gray-100 flex items-center justify-between px-4 md:px-6 shadow-soft">
      {/* 左侧 - 菜单按钮（移动端）和搜索框 */}
      <div className="flex items-center gap-3 flex-1">
        {/* 移动端菜单按钮 */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100 text-gray-600 transition-all duration-200 hover:scale-110 active:scale-95"
          aria-label="打开菜单"
        >
          <svg className="w-6 h-6 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        
        {/* 搜索框 */}
        <div className="relative flex-1 max-w-md">
          <input
            type="text"
            placeholder="搜索..."
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 bg-gray-50/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm transition-colors duration-200"
          />
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            🔍
          </span>
        </div>
      </div>
    </header>
  )
}
